import { SessionService as AuthSessionService } from '@blakeelearning/auth'

export default AuthSessionService

declare module '@ember/service' {
  interface Registry {
    'auth-session': AuthSessionService
  }
}
